const getType = (obj: any) => Object.prototype.toString.call(obj);

const isObject = (target: any) =>
    (typeof target === 'object' || typeof target === 'function') &&
    target !== null;

const canTraverse = {
    '[object Map]': true,
    '[object Set]': true,
    '[object Array]': true,
    '[object Object]': true,
    '[object Arguments]': true,
};
const mapTag = '[object Map]';
const setTag = '[object Set]';
const boolTag = '[object Boolean]';
const numberTag = '[object Number]';
const stringTag = '[object String]';
const symbolTag = '[object Symbol]';
const dateTag = '[object Date]';
const errorTag = '[object Error]';
const regexpTag = '[object RegExp]';

const handleRegExp = (target: any) => {
    const { source, flags } = target;
    return new target.constructor(source, flags);
};

const handleNotTraverse = (target: any, tag: any) => {
    const Ctor = target.constructor;
    switch (tag) {
        case boolTag:
            // eslint-disable-next-line
            return new Object(Boolean.prototype.valueOf.call(target));
        case numberTag:
            // eslint-disable-next-line
            return new Object(Number.prototype.valueOf.call(target));
        case stringTag:
            // eslint-disable-next-line
            return new Object(String.prototype.valueOf.call(target));
        case symbolTag:
            // eslint-disable-next-line
            return new Object(Symbol.prototype.valueOf.call(target));
        case errorTag:
        case dateTag:
            return new Ctor(target);
        case regexpTag:
            return handleRegExp(target);
        default:
            return new Ctor(target);
    }
};

const deepClone = (target: any, map = new WeakMap()) => {
    if (!isObject(target)) {
        return target;
    }
    const type = getType(target);
    let cloneTarget: any;
    // @ts-ignore
    if (!canTraverse[type]) {
        return handleNotTraverse(target, type);
        // eslint-disable-next-line
    } else {
        // eslint-disable-next-line
        let ctor = target.constructor;
        // eslint-disable-next-line
        cloneTarget = new ctor();
    }

    if (map.get(target)) {
        return target;
    }
    map.set(target, true);

    if (type === mapTag) {
        target.forEach((item: any, key: number) => {
            cloneTarget.set(deepClone(key, map), deepClone(item, map));
        });
    }

    if (type === setTag) {
        target.forEach((item: any) => {
            cloneTarget.add(deepClone(item, map));
        });
    }

    // 处理数组和对象
    for (const prop in target) {
        // eslint-disable-next-line
        if (target.hasOwnProperty(prop)) {
            cloneTarget[prop] = deepClone(target[prop], map);
        }
    }
    return cloneTarget;
};

export default deepClone;
